<template>
  <div class="w-100 bg-white">
    <Navbar />
    <block :height="83"></block>
    <div class="ga-container d-block pb-5">
      <div v-if="is_load.general" class="w-100 py-4">
        <loader />
      </div>
      <template v-else>
        <div class="w-100 pt-4" v-if="error.general != ''">
          <ErrorMessage :message="error.general"></ErrorMessage>
        </div>
        <div v-else class="w-100">
          <div class="row">
            
            <!-- STEPPER -->
            <div class="col-12 mb-5" id="top-section">
              <stepper :step="step" :need_payment="need_payment"></stepper>
            </div>

            <!-- MAIN CONTENT -->
            <div class="col-xl-8 col-lg-7 col-md-12 order-lg-1 order-2">
              <template v-if="!payment_in_page">
                <!-- GUEST INFORMATION -->
                <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                  <p class="mb-4 heading-6-1">Fill in data</p>
                  <div class="p-3 border-semi-grey rounded-6 position-relative mb-5" v-if="!isLoggedIn">
                    <div class="w-100 z-index-1029 position-relative">
                      <div class="row no-gutters">
                        <div class="col-xl-1 col-lg-2 col-md-1 col-sm-2 col-3 align-self-center">
                          <svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M20.7197 23.4622C26.0828 23.4622 30.6089 18.7115 30.6089 12.57C30.6089 6.5416 26.0494 1.95416 20.7197 1.95416C15.39 1.95416 10.8305 6.62643 10.8349 12.6146C10.8394 18.7115 15.3812 23.4622 20.7197 23.4622ZM4.40358 46.2676H36.5789C36.3024 45.675 36.1641 45.042 36.1641 44.3688V35.3786C34.8003 34.2997 33.7874 32.8695 33.1942 31.2659C29.9529 29.2092 25.7191 27.8148 20.7197 27.8148C8.00167 27.8148 0 36.4888 0 42.7956C0 44.9625 1.64828 46.2676 4.40358 46.2676Z"
                              class="fill-primary" />
                            <path
                              d="M42.4595 18.5428C38.2325 18.5428 34.8879 21.9119 34.8879 26.07C34.8879 29.2144 36.74 31.9443 39.573 33.1029V44.3688C39.573 44.7026 39.7332 44.965 39.9646 45.2233L41.9566 47.2001C42.2302 47.4603 42.6615 47.4894 42.9929 47.1825L46.6416 43.5137C46.9774 43.1936 46.9642 42.7602 46.6326 42.4445L44.5138 40.2877L47.5221 37.3598C47.8133 37.0485 47.7976 36.6019 47.4819 36.2461L44.5868 33.3466C48.0446 31.8738 49.9998 29.2527 49.9998 26.07C49.9998 21.9119 46.6308 18.5428 42.4595 18.5428ZM42.4394 22.2234C43.6853 22.2234 44.7149 23.2685 44.7149 24.4987C44.7149 25.8048 43.6853 26.8342 42.4394 26.8342C41.1824 26.8342 40.1284 25.8048 40.1284 24.4987C40.1284 23.2685 41.1579 22.2234 42.4394 22.2234Z"
                              class="fill-primary" />
                          </svg>
                        </div>
                        <div class="col-xl-9 col-lg-10 col-md-9 col-sm-10 col-9 align-self-center">
                          <div class="pl-3" :class="window_width >= 1200 ? 'w-85' : 'w-100'">
                            <p class="mb-1" :class="{
                              'body-1-4': window_width >= 576,
                              'body-2-4': window_width < 576
                            }">Unlock More Benefits with an Account</p>
                            <p class="mb-0" :class="{
                              'body-2-2': window_width >= 576,
                              'body-3-3': window_width < 576
                            }">Enjoy Faster Transactions and Easy Order History Access</p>
                          </div>
                        </div>
                        <div class="col-xl-2 col-lg-12 col-md-2 mt-xl-0 mt-lg-3 mt-md-0 mt-3 align-self-center">
                          <div class="row slim-grid-row">
                            <div class="col-xl-12 col-lg-6 col-md-12 col-6">
                              <button class="g-btn g-btn-primary g-btn-md w-100 mb-2"
                                @click="goToAuthPage('Login')">Login</button>
                            </div>
                            <div class="col-xl-12 col-lg-6 col-md-12 col-6">
                              <button class="g-btn g-btn-secondary g-btn-md w-100"
                                @click="goToAuthPage('Register')">Register</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12"
                      style="top:0;left:0;opacity:0.02"></div>
                  </div>
                  <GuestForm ref="guestForm"></GuestForm>
                  <div class="w-100 mb-3 pt-4 mt-4 border-t-form" id="middle-section">
                    <label class="body-2 mb-1 d-block">Special request</label>
                    <textarea class="p-3 body-2-1 w-100 border-form radius-6" v-model="note">
                    </textarea>
                  </div>
                  <div class="w-100">
                    <p class="mb-0 body-3-3-1"><span class="font-weight-bold text-danger">* </span>Required field</p> 
                  </div>
                </div>
                
                <!-- PAYMENT -->
                <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                  <div class="w-100"
                    :class="{
                      'mb-3': general_data.payment_mode != 'PAY_LATER'
                    }">
                    <p class="mb-0 heading-6-1">{{ general_data.payment_mode == 'PAY_IMMEDIATELY' ? 'Payment Method' : 'Payment Option' }}</p>
                    <p class="mb-0 body-2-1">{{ general_data.payment_mode == 'PAY_LATER' ? 'Book your spa reservation now and pay after your treatment is complete.' : "Select How You'd Like to Pay for a Hassle-Free Experience" }}</p>
                  </div>

                  <!-- PAYMENT MODE -->
                  <div class="row" v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
                    <div class="col-xl-6 col-12 mb-xl-0 mb-3" v-for="(p_mode,p_mode_i) in payment_mode.list">
                      <div class="w-100 radius-6 cursor-pointer" @click="paymentModeSelect(p_mode)" :class="p_mode.id != payment_mode.data.id ? 'border-form' : 'border-2-green'">
                        <div class="row no-gutters align-items-center py-2">
                          <div class="col-2 text-center">
                            <svg v-if="p_mode.id != payment_mode.data.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                                fill="#222222" />
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                            </svg>
                          </div>
                          <div class="col-10">
                            <div class="w-100 pr-3">
                              <p class="mb-0" :class="
                                {
                                  'text-green': p_mode.id == payment_mode.data.id,
                                  'body-1-4': window_width >= 576,
                                  'body-2-4': window_width < 576
                                }
                              ">{{ p_mode.title }}</p>
                              <p class="mb-0" :class="{
                                  'text-green': p_mode.id == payment_mode.data.id,
                                  'body-2-2': window_width >= 576,
                                  'body-3-3': window_width < 576
                                }">{{ p_mode.description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-100 mt-2" v-if="error.form.payment_mode">
                    <p class="mb-0 body-2 text-danger">Please select payment option</p>
                  </div>

                  <!-- PAYMENT METHOD -->
                  <div v-if="general_data.payment_mode == 'PAY_IMMEDIATELY' || (general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.data.id == 'PAY_IMMEDIATELY')" class="w-100" :class="{
                    'mt-4 pt-4 border-t-form-2-dashed': general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.data.id == 'PAY_IMMEDIATELY'                }">
                    <p class="mb-3 body-2-1" v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">Select payment method</p>
                    <div class="w-100">
                      <PaymentMethod ref="payment_method" module="concierge" :sub_module="payment_module" @selectPayment="selectPayment"></PaymentMethod>
                    </div>
                  </div>
                </div>
  
                <!-- BUTTON -->
                <div class="w-100">
                  <div class="w-100 mb-4" v-if="error.push != ''">
                    <ErrorMessage :message="error.push"></ErrorMessage>
                  </div>
                  
                  <state-button variant="secondary" size="xl" :click="submitForm" block>{{ btn_text }}</state-button>
                </div>
              </template>
              <div v-else class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                <XenditInputCC
                  :tx_payment="tx_payment"
                  module_page="CONCIERGE"
                  @done="clearCart"
                  @expired="goToListPage">
                </XenditInputCC>
              </div>
            </div>

            <!-- SIDERBAR -->
            <div class="col-xl-4 col-lg-5 col-md-12 order-lg-2 order-1 mb-lg-0 mb-5">
              <div class="general-booking-summary">
                <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey overflow-hidden">
                  <div class="p-4 bg-top-black">
                    <p class="mb-0 body-2-2 font-semibold text-16 text-white">Booking Summary</p>
                    <p class="mb-0 body-2-2 font-bold text-20 text-white">{{ getMerchant.name }}</p>
                  </div>
                  <div class="px-4 pt-4 border-b-semi-grey">
                    <CartTimer v-if="$isNotEmpty(getActivityTrxExpiredAt)" />
                    <div class="row no-gutters mb-4" v-for="(product_cart,product_cart_i) in getActivityTrxProducts">
                      <div class="col-8">
                        <p class="mb-2 body-1-4 ">{{ product_cart.original_data.name }}</p>
                        <div class="w-100 no-ws mb-1">
                          <div class="d-inline-block align-middle mr-2">
                            <svg class="lh-1" width="20" height="20" viewBox="0 0 20 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M2.45504 16.9507H13.1352C14.7693 16.9507 15.5825 16.1376 15.5825 14.5269V4.98045C15.5825 3.36982 14.7693 2.55669 13.1352 2.55669H2.45504C0.820954 2.55669 0 3.362 0 4.98045V14.5269C0 16.1454 0.820954 16.9507 2.45504 16.9507ZM2.33776 15.6919C1.64191 15.6919 1.2588 15.3245 1.2588 14.5973V7.22437C1.2588 6.50508 1.64191 6.12979 2.33776 6.12979H13.2369C13.9327 6.12979 14.3237 6.50508 14.3237 7.22437V14.5973C14.3237 15.3245 13.9327 15.6919 13.2369 15.6919H2.33776Z"
                                fill="black" fill-opacity="0.85" />
                              <path
                                d="M6.27053 8.93664H6.7318C7.00548 8.93664 7.09148 8.85844 7.09148 8.58483V8.12354C7.09148 7.84986 7.00548 7.76385 6.7318 7.76385H6.27053C5.99688 7.76385 5.90306 7.84986 5.90306 8.12354V8.58483C5.90306 8.85844 5.99688 8.93664 6.27053 8.93664ZM8.86633 8.93664H9.32762C9.60124 8.93664 9.69504 8.85844 9.69504 8.58483V8.12354C9.69504 7.84986 9.60124 7.76385 9.32762 7.76385H8.86633C8.59265 7.76385 8.49884 7.84986 8.49884 8.12354V8.58483C8.49884 8.85844 8.59265 8.93664 8.86633 8.93664ZM11.4621 8.93664H11.9234C12.197 8.93664 12.2909 8.85844 12.2909 8.58483V8.12354C12.2909 7.84986 12.197 7.76385 11.9234 7.76385H11.4621C11.1884 7.76385 11.1024 7.84986 11.1024 8.12354V8.58483C11.1024 8.85844 11.1884 8.93664 11.4621 8.93664ZM3.67475 11.4934H4.12824C4.40971 11.4934 4.49571 11.4152 4.49571 11.1415V10.6802C4.49571 10.4066 4.40971 10.3284 4.12824 10.3284H3.67475C3.39329 10.3284 3.30728 10.4066 3.30728 10.6802V11.1415C3.30728 11.4152 3.39329 11.4934 3.67475 11.4934ZM6.27053 11.4934H6.7318C7.00548 11.4934 7.09148 11.4152 7.09148 11.1415V10.6802C7.09148 10.4066 7.00548 10.3284 6.7318 10.3284H6.27053C5.99688 10.3284 5.90306 10.4066 5.90306 10.6802V11.1415C5.90306 11.4152 5.99688 11.4934 6.27053 11.4934ZM8.86633 11.4934H9.32762C9.60124 11.4934 9.69504 11.4152 9.69504 11.1415V10.6802C9.69504 10.4066 9.60124 10.3284 9.32762 10.3284H8.86633C8.59265 10.3284 8.49884 10.4066 8.49884 10.6802V11.1415C8.49884 11.4152 8.59265 11.4934 8.86633 11.4934ZM3.67475 14.0578H4.12824C4.40971 14.0578 4.49571 13.9718 4.49571 13.6982V13.2369C4.49571 12.9632 4.40971 12.885 4.12824 12.885H3.67475C3.39329 12.885 3.30728 12.9632 3.30728 13.2369V13.6982C3.30728 13.9718 3.39329 14.0578 3.67475 14.0578ZM6.27053 14.0578H6.7318C7.00548 14.0578 7.09148 13.9718 7.09148 13.6982V13.2369C7.09148 12.9632 7.00548 12.885 6.7318 12.885H6.27053C5.99688 12.885 5.90306 12.9632 5.90306 13.2369V13.6982C5.90306 13.9718 5.99688 14.0578 6.27053 14.0578ZM8.86633 14.0578H9.32762C9.60124 14.0578 9.69504 13.9718 9.69504 13.6982V13.2369C9.69504 12.9632 9.60124 12.885 9.32762 12.885H8.86633C8.59265 12.885 8.49884 12.9632 8.49884 13.2369V13.6982C8.49884 13.9718 8.59265 14.0578 8.86633 14.0578Z"
                                fill="black" fill-opacity="0.85" />
                              <path
                                d="M14.9648 19.4917C17.7092 19.4917 20 17.2009 20 14.4487C20 11.681 17.7326 9.40581 14.9648 9.40581C12.197 9.40581 9.92181 11.6888 9.92181 14.4487C9.92181 17.2244 12.1892 19.4917 14.9648 19.4917Z"
                                fill="white" />
                              <path
                                d="M14.9648 18.4206C17.1149 18.4206 18.9366 16.6224 18.9366 14.4487C18.9366 12.2674 17.1384 10.4769 14.9648 10.4769C12.7834 10.4769 10.993 12.2752 10.993 14.4487C10.993 16.638 12.7834 18.4206 14.9648 18.4206Z"
                                class="fill-success" />
                              <path
                                d="M14.4878 16.5911C14.3549 16.5911 14.1985 16.5363 14.0969 16.4269L12.7756 14.9726C12.6818 14.871 12.6427 14.7302 12.6427 14.6208C12.6427 14.3393 12.8616 14.1282 13.1352 14.1282C13.2994 14.1282 13.4245 14.2064 13.5027 14.2924L14.4644 15.3323L16.3722 12.6895C16.466 12.5644 16.6067 12.4706 16.7866 12.4706C17.0446 12.4706 17.2791 12.6817 17.2791 12.9554C17.2791 13.0414 17.24 13.1508 17.1697 13.2525L14.9022 16.4034C14.8162 16.5207 14.6599 16.5911 14.4878 16.5911Z"
                                fill="white" />
                            </svg>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">
                            {{ $formatDate(product_cart.service_date) }}</p>
                        </div>
                        <div class="w-100 no-ws mb-1">
                          <div class="d-inline-block align-middle mr-2">
                            <svg class="lh-1" width="20" height="19" viewBox="0 0 20 19" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_499_24)">
                                <path
                                  d="M3.89193 9.98433H7.97963C8.28501 9.98433 8.52778 9.74938 8.52778 9.43618V4.15818C8.52778 3.85278 8.28501 3.61785 7.97963 3.61785C7.67425 3.61785 7.4393 3.85278 7.4393 4.15818V8.89585H3.89193C3.5787 8.89585 3.34378 9.1308 3.34378 9.43618C3.34378 9.74938 3.5787 9.98433 3.89193 9.98433ZM7.98745 17.1261C12.3571 17.1261 15.9749 13.5004 15.9749 9.13862C15.9749 4.76899 12.3493 1.15114 7.97963 1.15114C3.61785 1.15114 0 4.76899 0 9.13862C0 13.5004 3.62568 17.1261 7.98745 17.1261ZM7.98745 15.7948C4.29131 15.7948 1.33908 12.8347 1.33908 9.13862C1.33908 5.44244 4.28348 2.48238 7.97963 2.48238C11.6758 2.48238 14.6437 5.44244 14.6437 9.13862C14.6437 12.8347 11.6836 15.7948 7.98745 15.7948Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M14.9491 18.285C17.7055 18.285 20 15.9906 20 13.2341C20 10.462 17.7212 8.18324 14.9491 8.18324C12.1848 8.18324 9.90601 10.462 9.90601 13.2341C9.90601 16.0141 12.177 18.285 14.9491 18.285Z"
                                  fill="white" />
                                <path
                                  d="M14.9491 17.2122C17.1104 17.2122 18.9271 15.4111 18.9271 13.2341C18.9271 11.0494 17.1339 9.25609 14.9491 9.25609C12.7721 9.25609 10.971 11.0572 10.971 13.2341C10.971 15.4267 12.7721 17.2122 14.9491 17.2122Z"
                                  class="fill-success" />
                                <path
                                  d="M14.4714 15.3798C14.3462 15.3798 14.1817 15.325 14.0799 15.2153L12.7564 13.7588C12.6625 13.657 12.6311 13.5161 12.6311 13.4064C12.6311 13.1245 12.8426 12.9131 13.1167 12.9131C13.2811 12.9131 13.4064 12.9914 13.4926 13.0775L14.4557 14.119L16.3665 11.4722C16.4526 11.3391 16.6014 11.2529 16.7737 11.2529C17.0399 11.2529 17.267 11.4643 17.267 11.7384C17.267 11.8246 17.2357 11.9342 17.1574 12.036L14.8864 15.1919C14.8003 15.3093 14.6437 15.3798 14.4714 15.3798Z"
                                  fill="white" />
                              </g>
                              <defs>
                                <clipPath id="clip0_499_24">
                                  <rect width="20" height="18.285" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">
                            {{ $customFormatDateTime(product_cart.service_time.schedule_start, "HH:mm:ss", "hh:mm A") }}
                          </p>
                        </div>
                      </div>
                      <div class="col-4 text-right">
                        <p class="text-16 font-lato mb-2 text-semi-dark">
                          {{ $formatCurrency(product_cart.base_price.base) }}</p>
                        <div class="w-100 no-ws mb-1 text-right">
                          <div class="d-inline-block align-middle mr-1">
                            <svg class="lh-1" width="17" height="20" viewBox="0 0 17 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_500_31)">
                                <path
                                  d="M1.75168 16.6171H10.7389C11.9258 16.6171 12.4906 16.2596 12.4906 15.4732C12.4906 13.5999 10.1241 10.8902 6.24888 10.8902C2.36657 10.8902 0 13.5999 0 15.4732C0 16.2596 0.564829 16.6171 1.75168 16.6171ZM1.41565 15.5375C1.22975 15.5375 1.15111 15.4874 1.15111 15.3373C1.15111 14.1576 2.96714 11.9698 6.24888 11.9698C9.52347 11.9698 11.3395 14.1576 11.3395 15.3373C11.3395 15.4874 11.268 15.5375 11.0821 15.5375H1.41565ZM6.24888 9.99643C7.95048 9.99643 9.33757 8.48787 9.33757 6.6432C9.33757 4.81287 7.95768 3.37578 6.24888 3.37578C4.55438 3.37578 3.16019 4.84147 3.16019 6.65754C3.16019 8.49501 4.54723 9.99643 6.24888 9.99643ZM6.24888 8.91684C5.20501 8.91684 4.3113 7.92303 4.3113 6.65754C4.3113 5.41345 5.19071 4.45539 6.24888 4.45539C7.3142 4.45539 8.18647 5.392 8.18647 6.6432C8.18647 7.90869 7.29986 8.91684 6.24888 8.91684Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M7.95769 15.9236C7.95769 17.7253 8.92288 18.4474 11.1893 19.7773C11.6612 20.0561 12.3119 20.0919 12.841 19.7773C15.1074 18.4474 16.0798 17.7253 16.0798 15.9236V13.3568C16.0798 12.5704 15.7151 11.8983 14.9001 11.598L12.6979 10.7829C12.2546 10.6184 11.7328 10.6399 11.2537 10.8187L9.1302 11.598C8.32229 11.8911 7.95769 12.5704 7.95769 13.3568V15.9236Z"
                                  fill="white" />
                                <path
                                  d="M8.93715 16.038C8.93715 17.4108 9.73792 17.9112 11.6826 19.048C11.8543 19.1552 12.126 19.1767 12.3476 19.048C14.2923 17.904 15.1002 17.4108 15.1002 16.038V13.4641C15.1002 13.0494 14.943 12.7777 14.5211 12.5989C14.0993 12.4274 12.7766 11.9554 12.369 11.8125C12.1331 11.7339 11.8686 11.7339 11.604 11.841C11.2537 11.9698 9.93096 12.4274 9.51633 12.5989C9.09444 12.7777 8.93715 13.0494 8.93715 13.4641V16.038Z"
                                  class="fill-success" />
                                <path
                                  d="M11.5826 17.332C11.4682 17.332 11.318 17.282 11.2323 17.1748L10.0168 15.8521C9.93816 15.7591 9.9024 15.6304 9.9024 15.5232C9.9024 15.2729 10.0954 15.0727 10.3457 15.0727C10.4958 15.0727 10.6102 15.1442 10.6888 15.23L11.5683 16.1809L13.3128 13.7572C13.3914 13.6428 13.5273 13.5642 13.6917 13.5642C13.9277 13.5642 14.1422 13.7501 14.1422 14.0074C14.1422 14.0861 14.1064 14.1862 14.0421 14.272L11.9615 17.1605C11.8829 17.2606 11.7399 17.332 11.5826 17.332Z"
                                  fill="white" />
                              </g>
                              <defs>
                                <clipPath id="clip0_500_31">
                                  <rect width="16.0798" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">{{ product_cart.qty }} Person</p>
                        </div>
                        <div class="d-table ml-auto cursor-pointer" v-if="step == 2">
                          <svg class="cursor-pointer" @click="removeProductCart(product_cart.original_data)" width="13"
                            height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_201_6878)">
                              <path
                                d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                                fill="#DC3545" />
                            </g>
                            <defs>
                              <clipPath id="clip0_201_6878">
                                <rect width="12.8798" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-4 border-b-semi-grey">
                    <PromoCode :api_module="api_module" :page_module="page_module" :general_data="general_data"></PromoCode>
                  </div>
                  <div class="w-100 p-4">
                    <div class="row mb-2">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Subtotal</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(getActivityTrxSubTotal) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Discount</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0" :class="{
                          'text-orange': getActivityTrxPromotion > 0
                        }">{{getActivityTrxPromotion > 0? '-' : ''}}{{ $formatCurrency(getActivityTrxPromotion) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Taxes & Services</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(getActivityTrxTaxService) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2" v-if="payment_surcharge > 0">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Payment Surcharge</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(payment_surcharge) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <p class="mb-0 body-1-4">Total</p>
                      </div>
                      <div class="col-8 text-right">
                        <p class="text-16 font-lato mb-0">{{ $formatCurrency(getActivityTrxTotal+payment_surcharge) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <Footer></Footer>

    <b-modal 
      ref="empty_cart" 
      centered 
      size="md" 
      hide-footer 
      hide-header
      no-close-on-backdrop 
      no-close-on-esc 
      body-class="p-0">
      <div class="py-5 px-4 text-center">
        <div class="mb-4">
          <img src="../../../../assets/img/icon/namaste.png" class="mb-4" width="200">
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">{{$t('ticket-cart.empty-cart.title')}}</p>
          <p class="mb-2 body-2-2">{{$t('ticket-cart.empty-cart.message')}}</p>
        </div>
        <button 
          @click="goToListPage()"
          class="g-btn g-btn-primary g-btn-lg" >
          Select activity
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import Footer from '@/components/hotel/concierge/general/Footer';
  import GuestForm from '@/components/hotel/concierge/activity/GuestForm';
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  import PromoCode from '@/components/hotel/concierge/activity/PromoCode';
  import PaymentMethod from '@/components/general/payment/PaymentMethod';
  import stepper from '@/components/general/stepper';
  import CartTimer from '@/components/hotel/concierge/pos/CartTimer';
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get,
    post
  } from '@/services/index.js'
  import moment from 'moment';

  export default {
    components: {
      Navbar,
      Footer,
      GuestForm,
      XenditInputCC,
      PromoCode,
      PaymentMethod,
      stepper,
      CartTimer
    },
    metaInfo() {
      return {
        title: this.page_title,
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data() {
      return {
        is_load: {
          general: true,
          payment_method: true
        },
        error: {
          general: '',
          payment_method: '',
          form:{
            payment_mode: false,
            payment_method: false
          },
          push: ''
        },
        step: 2,
        general_data: {},
        payment_mode: {
          list: [{
              id: 'PAY_IMMEDIATELY',
              title: 'Instant Payment',
              description: 'Pay now for your spa reservation quickly and effortlessly.'
            },
            {
              id: 'PAY_LATER',
              title: 'Pay Later',
              description: 'Book your spa reservation now and pay after your treatment is complete.'
            }
          ],
          data: {}
        },
        payment_method: {
          list: [],
          data: {}
        },
        note: '',
        reservation:{},
        tx_inquiry: {},
        tx_payment: {},
        payment_in_page: false,
        window_width: window.innerWidth
      }
    },
    computed: {
      ...mapGetters([
        'getMetaTitleTemplate',
        'isLoggedIn',
        'getMerchant',
        'getActivityTrxCustomerDetail',
        'getActivityTrxProducts',
        'getActivityTrxSubTotal',
        'getActivityTrxTaxService',
        'getActivityTrxPromotion',
        'getActivityTrxTotal',
        'isReservationActive',
        'getReservationActive',
        'isMembershipRewardApplied',
        'getUpsellRef',
        'getCurrentUser',
        'getActivityTrxPromoCode',
        'getActivityTrxExpiredAt',
        'getActivityTrxPageModule'
      ]),
      page_module(){
        if(this.$route.meta.sub_module) return this.$route.meta.sub_module
        return ''
      },
      api_module(){
        if(this.page_module == 'hotel-activity') return 'CORE_HOTEL'
        return 'CONCIERGE'
      },
      pos_code() {
        if(this.page_module == 'hotel-activity') return this.$route.params.pos_code
        return 'spa'
      },
      need_payment(){
        let general_loaded = this.general_data.id
        let default_payment_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY' 

        return general_loaded && (default_payment_now || selected_paymnet_now)
      },
      btn_text(){
        let text = 'Book Now'
        if(this.need_payment && this.cart_step == 2){
          text = 'Continue to payment'
        }
        return text
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.data.id){
					if(this.payment_method.data.surcharge_type == 'PERCENT'){
						total = (this.getActivityTrxTotal/100)*this.payment_method.data.surcharge_value
					}else{
						total = this.payment_method.data.surcharge_value
					}
				}

				return total
			},
      total_cart(){
        return this.getActivityTrxProducts.length
      },
      page_title(){
        if(this.general_data.id) return this.$isNotEmpty(this.general_data.tagline) ? this.general_data.tagline : this.general_data.name
        return ''
      },
      payment_module(){
        return this.page_module == 'hotel-activity' ? this.pos_code : this.page_module
      }
    },
    watch:{
      total_cart(){
        if(this.total_cart == 0){
          this.$refs.empty_cart.show()
        }
      }
    },
    mounted() {
      if(this.getActivityTrxProducts.length > 0){
        this.loadFirstData()
      }else{
        this.$refs.empty_cart.show()
      }
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods: {
      // GENERAL
      ...mapMutations(['setActiveRoute', 'setActivityTrxCustomerDetail', 'removeTrxActivityProduct','clearTrxActivityProduct']),
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      goToPage(page){
        this.$router.push({
          name: page,
          params: {
            merchant_code: this.getMerchant.code
          }
        })
      },
      goToAuthPage(page) {
        let active_page = this.page_module == 'concierge-spa' ? 'concierge/spa/cart' : `book/${this.pos_code}/cart`
        this.setActiveRoute(active_page)
        this.goToPage(page)
      },
      goToListPage(){
        let homepage = this.page_module == 'concierge-spa' ? 'ConciergeSpa' : 'HotelActivity'
        this.goToPage(homepage)
      },

      // IN PAGE ACTION
      removeProductCart(product) {
        this.removeTrxActivityProduct({
          product: product
        })
      },
      paymentModeSelect(pm){
        this.payment_mode.data = pm
      },
      selectPayment(pm) {
        this.payment_method.data = pm
      },
      fillCustomerData(with_rsv=true){
        let data = with_rsv ? this.reservation.guest_profile : this.getCurrentUser
        let vuex_data = this.$deepCopy(this.getActivityTrxCustomerDetail)
        let params = []
        if (!this.$isNotEmpty(vuex_data.first_name)) {
          params.push({
            key: 'first_name',
            value: with_rsv ? data.name : data.first_name
          })
        }
        if (!this.$isNotEmpty(vuex_data.last_name)) {
          params.push({
            key: 'last_name',
            value: with_rsv ? '' : data.last_name
          })
        }
        if (!this.$isNotEmpty(vuex_data.email)) {
          params.push({
            key: 'email',
            value: data.email
          })
        }
        if (!this.$isNotEmpty(vuex_data.phone_number)) {
          params.push({
            key: 'phone_number',
            value: data.phone
          })
        }
        if (params.length > 0) {
          this.setActivityTrxCustomerDetail(params)
        }
      },
      clearCart(){
        this.clearTrxActivityProduct()
      },
      
      // API
      loadFirstData() {
        this.is_load.general = true
        let func_exe = [this.loadGeneralData()]
        if(this.isReservationActive){
          func_exe.push(this.loadDetailReservation())
        }
        Promise.all(func_exe).finally(() => {
          let pos_id = this.page_module == 'concierge-spa' ? this.general_data.merchant_pos_id : this.general_data.id
          if(!(this.getActivityTrxPageModule == '' || this.getActivityTrxPageModule == pos_id)){
            this.clearTrxActivityProduct()
          }
          if(!this.isReservationActive && this.isLoggedIn){
            this.fillCustomerData(false)
          }
          this.is_load.general = false
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          let api_url = this.page_module == 'concierge-spa' ? 'spa/general' : `merchant-pos/${this.pos_code}/general`
          get(this.api_module, api_url, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>success()).catch(()=>fail())
            } else {
              this.error.general = res.message
              fail()
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
                this.fillCustomerData()
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},

      // SUBMIT
      getApiParams(type='inquiry'){ 
        let params = {}
        if(type == 'inquiry'){
          let getRoomId = () => {
            return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
          }
          let customer_data = this.getActivityTrxCustomerDetail
          params = {
            merchant_id: this.getMerchant.id,
            products:[],
            customer_detail: customer_data,
            room_id: getRoomId(),
            merchant_pos_id: this.page_module == 'concierge-spa' ? this.general_data.merchant_pos_id : this.general_data.id,
            notes: this.note,
            region: '',
            device: this.$getDeviceType(),
            promo_code: this.getActivityTrxPromoCode,
            campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
            guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
            reservation_id: this.reservation.id ? this.reservation.id : null,
            payment_mode: ''
          }

          if(this.isMembershipRewardApplied){
            params.membership_reward_id = this.getMembershipRewardApplied.id
          }

          this.getActivityTrxProducts.forEach(cart=>{
            let product_cart = {
              id: cart.original_data.product_ga_pos_id,
              qty: cart.qty,
              notes: '',
              therapist_gender: cart.therapist_gender,
              place_choice: cart.place_choice,
              service_date: moment(cart.service_date).format("YYYY-MM-DD"),
              schedule_id: cart.original_data.use_schedule ? cart.service_time.id : null
            }
            if(cart.original_data.use_schedule) product_cart.service_date += ' 00:00'
            else product_cart.service_date += ` ${moment(cart.service_time.schedule_start,'HH:mm:ss').format("HH:mm")}`

            params.products.push(product_cart)
          })

          if(this.general_data.payment_mode != 'PAY_IMMEDIATELY_OR_LATER'){
            params.payment_mode = this.general_data.payment_mode
          }else{
            params.payment_mode = this.payment_mode.data.id
          }
          
        }else{
          let total_amount = Number(this.tx_inquiry.total_payment)+Number(this.payment_surcharge)

          const { first_name, last_name, email, phone_number } = this.getActivityTrxCustomerDetail
          
          params = {
	      		merchant_id: this.getMerchant.id,
	      		tx_order_invoice_id: this.tx_inquiry.id,
	      		amount: Number(total_amount.toFixed(2)),
	      		customer_detail: {
	      			name: first_name,
              last_name: this.$isNotEmptyV2(last_name) ? last_name : '',
	      			email: email,
	      			phone_number: phone_number
	      		},
	      		payment_details: {
	      			id: this.payment_method.data.id,
	      			payment_method: this.payment_method.data.payment_method,
	      			bank_name: this.payment_method.data.bank_name,
	      			payment_channel: this.payment_method.data.payment_channel
	      		}
	      	}
        }

        return params
      },
      validateAllForm(){
        return new Promise((success,fail)=>{
          this.$refs.guestForm.validateForm().then(() => {
            this.error.form.payment_mode = false
            let p_mode = this.general_data.payment_mode
            let valid = true
            if(p_mode != 'PAY_LATER'){
              let is_payment_mode_not_selected = p_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode.data.id
              let is_payment_method = (p_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY' ) || p_mode == 'PAY_IMMEDIATELY'

              if(is_payment_mode_not_selected){
                this.error.form.payment_mode = true
                valid = false
              }else if(is_payment_method){
                this.$refs.payment_method.validateForm().then(()=>valid=true).catch(()=>valid=false)
              }
            }
            setTimeout(()=>{
              if(!valid){
                this.$smoothScroll('middle-section')
                fail()
              }else{
                success()
              }
            },300)
          }).catch(() => {
            this.$smoothScroll('top-section')
            fail()
          })
        })
      },
      submitForm() {
        return new Promise((success, fail) => {
          this.validateAllForm().then(()=>{
            this.pushApiInquiry().then(res=>{
              if(this.need_payment){
                this.tx_inquiry = res.data
                this.pushApiPayment().then(()=>{
                  success()
                }).catch(err=>{
                  this.error.push = err
                  fail()
                })
              }else{
                this.clearCart()
                this.$router.push(`/${this.getMerchant.code}/concierge/trx-result/${res.data.id}`)
                success()
              }
            }).catch(err=>{
              this.error.push = err
              fail()
            })
          }).catch(()=>{
            fail()
          })
        })
      },
      pushApiInquiry(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams()
          post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
            let res = response.data
            if(res.success){
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
      pushApiPayment(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams('payment')
	      	post("CORE_HOTEL","merchant-pos/tx-payment",params).then(response=>{
            let res = response.data
            if(res.success){
              if(this.payment_method.data.bank_name == 'XENDIT' && this.payment_method.data.payment_method == 'CREDIT_CARD'){
                this.tx_payment = res.payment
                this.tx_payment.tx_order_id_2 = res.tx_order_id 
                this.payment_in_page = true
                this.step = 3
              }else{
                this.$proceedPayment('CONCIERGE',this.tx_inquiry,res,this.payment_method.data)
              }
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
    }
  }

</script>
<style>
   .svg-primary {
    fill: var(--merchant-primary-color)
  }

</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/activity/Cart.vue